import { Button } from "./ui/button";
import { Printer } from "lucide-react";

/**
 * Trigger the browser print dialog. Users pick "Save as PDF" from
 * the dialog to archive a versioned copy of the legal document.
 */
export function PrintPdfButton({ label = "Download as PDF", testId = "print-pdf-btn" }) {
    return (
        <Button
            type="button"
            variant="outline"
            size="sm"
            className="no-print gap-2"
            onClick={() => window.print()}
            data-testid={testId}
        >
            <Printer className="h-4 w-4" /> {label}
        </Button>
    );
}
